import getGeolocation, {confirmChannelChange} from "../../api/countryRedirect"
import {COUNTRY_SELECTOR_REDIRECT_QUERY_STRING} from "../../config/constants"

import {handleCountryChange} from "./openCountrySelector"
import {SessionUpdate} from "./sessionUpdate"
import {fetchRetry, GetDevOverrideIpAddress, IsApplicable} from "./utils"
import {doCountryRedirect} from "../featureSwitch"

interface CountryRedirectParams {
    Version: number
    PopupDisplayed: boolean | null
    ShowPopup: boolean | null
    PopupDate: string | null
    ISOCode: string | null
    CountryName: string | null
    RedirectUrl: string | null
}

// countryRedirectParams -bag/get CountryRedirect.  If you have previously been shown the country redirect, it will be set here
// territory - x-next-territory
// GeolocationVersion - feature settings GeolocationVersion
export const PerformCountryRedirectCheck = async (
    countryRedirectParams: CountryRedirectParams | null,
    territory: string,
    GeolocationVersion: number,
    siteUrl: string,
    geolocationUrl: string,
    doCountrySelectorRedirect: boolean,
    countrySelectorEndpoint: string,
): Promise<void> => {
    if (!doCountryRedirect() && !doCountrySelectorRedirect) return

    const countryCode = territory.toUpperCase()

    if (!IsApplicable()) {
        return
    }

    if (!countryRedirectParams) {
        await callGeolocationApi(
            GeolocationVersion,
            siteUrl,
            countryCode,
            geolocationUrl,
            doCountrySelectorRedirect,
            countrySelectorEndpoint,
        )
        return
    }
    if (countryRedirectParams.Version < GeolocationVersion && !countryRedirectParams.PopupDisplayed) {
        await callGeolocationApi(
            GeolocationVersion,
            siteUrl,
            countryCode,
            geolocationUrl,
            doCountrySelectorRedirect,
            countrySelectorEndpoint,
        )
        return
    }

    if (countryRedirectParams.ShowPopup) {
        const currentDate = new Date()
        const popupDate = countryRedirectParams.PopupDate
            ? new Date(parseInt(countryRedirectParams.PopupDate.substr(6), 10))
            : null
        if (!popupDate || popupDate < currentDate) {
            const country = {
                ISOCountryCode: countryRedirectParams.ISOCode,
                ISOCountryName: countryRedirectParams.CountryName,
                RedirectUrl: countryRedirectParams.RedirectUrl,
            }
            await handleCountryChange(
                countryCode,
                country,
                GeolocationVersion,
                siteUrl,
                doCountrySelectorRedirect,
                countrySelectorEndpoint,
            )
        }
    }
}

export const callGeolocationApi = async (
    GeolocationVersion: number,
    siteUrl: string,
    countryCode: string,
    geolocationUrl: string,
    doCountrySelectorRedirect: boolean,
    countrySelectorEndpoint: string,
) => {
    const geolocationData = await getGeolocation(geolocationUrl, GetDevOverrideIpAddress())

    if (!geolocationData || !geolocationData.ISOCountryCode || !geolocationData.ISOCountryName) {
        await fetchRetry((attempt: number) =>
            SessionUpdate(false, false, geolocationData, GeolocationVersion, siteUrl, attempt),
        )
        return
    }
    await handleCountryChange(
        countryCode,
        geolocationData,
        GeolocationVersion,
        siteUrl,
        doCountrySelectorRedirect,
        countrySelectorEndpoint,
    )
}

export const callConfirmChannelApi = async (siteUrl: string, newSiteUrl: string | undefined) => {
    await confirmChannelChange(siteUrl, newSiteUrl)
}

export const fromCountrySelectorPage = (url: string): boolean => {
    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""
    const urlParams = new URLSearchParams(trimmedUrl).get(COUNTRY_SELECTOR_REDIRECT_QUERY_STRING)?.toLowerCase() || ""
    return urlParams === "true"
}

export default PerformCountryRedirectCheck
